import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function BasicComponents(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '0px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2 style={{whiteSpace:'normal'}}>Basic Components</h2>
                <li>
                    <Link to={`${url}/wires`}>Wires</Link>
                </li>
                <li>
                    <Link to={`${url}/cables`}>Cables</Link>
                </li>
                <li>
                    <Link to={`${url}/connectors`}>Connectors</Link>
                </li>
                <li>
                    <Link to={`${url}/batteries`}>Batteries</Link>
                </li>
                <li>
                    <Link to={`${url}/switches`}>Switches</Link>
                </li>
                <li>
                    <Link to={`${url}/relays`}>Relays</Link>
                </li>
                <li>
                    <Link to={`${url}/resistors`}>Resistors</Link>
                </li>
                <li>
                    <Link to={`${url}/capacitors`}>Capacitors</Link>
                </li>
                <li>
                    <Link to={`${url}/inductors`}>Inductors</Link>
                </li>
             
                <li>
                    <Link to={`${url}/solenoids`}>Solenoids</Link>
                </li>    
                <li>
                    <Link to={`${url}/fans`}>Fans</Link>
                </li>  
                <li>
                    <Link to={`${url}/transistors`}>Transistors</Link>
                </li> 
                <li>
                    <Link to={`${url}/fuses`}>Fuses</Link>
                </li> 
                <li>
                    <Link to={`${url}/diodes`}>Diodes</Link>
                </li> 
                <li>
                    <Link to={`${url}/grommets`}>Grommets</Link>
                </li>              
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default BasicComponents; 